"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "coli": {
    "659a0ac6": [{
      "hkey": "8dc25b25",
      "slug": "coli",
      "name": "Coli",
      "primary": true,
      "skipSearch": false
    }],
    "peli": [{
      "hkey": "8dc25b25",
      "slug": "coli",
      "name": "Coli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "858b5d88": [{
      "hkey": "8dc25b25",
      "slug": "coli",
      "name": "Coli",
      "primary": true,
      "skipSearch": false
    }],
    "rosso": [{
      "hkey": "8dc25b25",
      "slug": "coli",
      "name": "Coli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "867c9874": [{
      "hkey": "2a1778bf",
      "slug": "scabiazza",
      "name": "Scabiazza",
      "primary": true,
      "skipSearch": false
    }],
    "scabiazze": [{
      "hkey": "2a1778bf",
      "slug": "scabiazza",
      "name": "Scabiazza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;